<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      @openAddDialog="addInfo()"
      :submitService="submitService"
      addShowPower="/tatsms/add"
      :submitData="submitData"
      @success="onSuccess"
    >
      <select-organs v-model="formModel.tatSimpleId"></select-organs>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="tatSimpleId"
        label="机构简称"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="chnId"
        label="通道名称"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="feeType"
        label="计费类型"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ scope.row.feeType == 1 ? "费率" : "笔" }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="feeAmt"
        label="计费标准（元）"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.feeAmt * 100) / 10000) }}</p>
        </template>
      </el-table-column>
      <!--<el-table-column prop="modifier" label="修改人"></el-table-column>-->
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ scope.row.status == 0 ? "禁用" : "启用" }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="160"
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="150"
        v-if="
          hasPerm('/tatsms/edit') ||
          hasPerm('/tatsms/delete') ||
          hasPerm('/tatsms/udpStatus')
        "
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="updateInfo(scope.row.id)"
            v-if="hasPerm('/tatsms/edit')"
            >修改</el-button
          >
          <el-button
            type="text"
            @click="DeleteInfo(scope.row.id)"
            class="button-color"
            v-if="hasPerm('/tatsms/delete')"
            >删除</el-button
          >
          <el-button
            type="text"
            @click="Disabled(scope.row.id, scope.row.status)"
            class="button-color"
            v-if="hasPerm('/tatsms/udpStatus')"
          >
            {{ scope.row.status == 1 ? "禁用" : "启用" }}
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="formDialogTitle"
      :model="dialogModel"
      :dialogService="dialogService"
      :submitData="dialogData"
      :rules="dialogRules"
      @success="dialogSuccess"
      @close="dialogClose"
      @opend="dialogOpen"
      class="note"
    >
      <select-organs
        v-model="dialogModel.tatSimpleId"
        :selectValue="dialogModel.tatSimpleId"
        :needAll="false"
        selectWidth="100%"
      ></select-organs>
      <el-form-item label="通道名称" prop="chnId">
        <!--<el-input v-model="dialogModel.chnId" placeholder="请输入通道名称"></el-input>-->
        <el-select v-model="dialogModel.chnId">
          <el-option
            v-for="item in chnNameList"
            :key="item.id"
            :label="item.shortName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计费方式" prop="feeType" v-if="noteId">
        <el-select v-model="dialogModel.feeType" :disabled="noteId != ''">
          <el-option
            v-for="item in feeTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计费标准" prop="feeAmt">
        <el-input-number
          v-model="dialogModel.feeAmt"
          :controls="false"
          controls-position="right"
          :precision="2"
          :step="0.1"
          @change="handleChange"
          :min="0"
          style="width: 91%"
        ></el-input-number>
        <!--<el-input v-model="dialogModel.feeAmt" placeholder="请输入计费标准"></el-input>-->
        <span>{{ dialogModel.feeType == 1 ? "%" : "元" }}</span>
      </el-form-item>
      <!--<el-form-item label="状态" prop="status">-->
      <!--<el-select v-model="dialogModel.status">-->
      <!--<el-option-->
      <!--v-for="item in status"-->
      <!--:key="item.value"-->
      <!--:label="item.label"-->
      <!--:value="item.value">-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->
      <el-form-item label="描述" prop="remark">
        <el-input
          maxlength="80"
          show-word-limit
          v-model="dialogModel.remark"
          type="textarea"
          resize="none"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import ElInput from "element-ui/packages/input/src/input";
import FormDialog from "../../dialog/FormDialog";
import SelectOrgans from "components/business/SelectOrgans";

import OrganService from "service/OrganService";
import ChannelService from "service/ChannelService";
import OrganNoteService from "service/OrganNoteService";
// import ChannelNoteService from "service/ChannelNoteService";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "organnote",
  data() {
    return {
      all: [
        {
          id: "",
          simpleName: "全部",
        },
      ],
      chnNameList: [],
      formModel: {
        tatSimpleId: "",
      },
      tableData: [],
      isPage: false,
      page: {},
      submitService: OrganNoteService.list,
      formDialogTitle: "",
      dialogModel: {
        tatSimpleId: "",
        chnId: "",
        feeType: "",
        feeAmt: "0",
        status: "",
        desc: "",
      },
      feeTypes: [],
      status: [
        {
          value: "0",
          label: "禁用",
        },
        {
          value: "1",
          label: "启用",
        },
      ],
      noteId: "",
      dialogRules: {
        tatSimpleId: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请选择机构简称"));
              } else {
                if (this.getTatSimpleId == value) {
                  return callback();
                }
                this.checkOnly(value, (res) => {
                  res.contents.checkFlag
                    ? callback(new Error("机构简称不能重复"))
                    : callback();
                });
              }
            },
          },
        ],
        feeAmt: [
          {
            required: true,
            message: "请输入收费标准",
          },
        ],
        chnId: [
          {
            required: true,
            message: "请选择通道名称",
          },
        ],
      },
      checkFlag: false,
      getTatSimpleId: "",
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    ElInput,
    CommonTopForm,
    CommonTable,
    SelectOrgans,
    FormDialog,
  },
  computed: {
    dialogService() {
      if (this.noteId) {
        return OrganNoteService.update;
      } else {
        return OrganNoteService.add;
      }
    },
    dialogData() {
      const params = {
        tatSimpleId: this.dialogModel.tatSimpleId,
        chnId: this.dialogModel.chnId,
        feeAmt: this.dialogModel.feeAmt,
        remark: this.dialogModel.remark,
        userId: this.userId,
      };
      if (this.noteId) {
        params.id = this.noteId;
      }
      if (
        this.dialogModel.remark == "" ||
        this.dialogModel.remark == undefined
      ) {
        delete params.remark;
      }
      return params;
    },
    submitData() {
      this.params = {
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
        tatSimpleId: this.formModel.tatSimpleId,
        userId: this.userId,
      };
      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  mounted() {
    this.getList();
    this.page = this.$refs.commonTable.page;
    this.getTypeNames("feeType", (res) => {
      this.feeTypes = res;
    });
  },
  methods: {
    handleChange(e) {},
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getchnNameList() {
      this.doLoad(
        ChannelNoteService.shortNames,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.chnNameList = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    addInfo() {
      this.formDialogTitle = "添加机构短信";
      this.$refs.formDialog.open();
      this.noteId = "";
    },
    updateInfo(id) {
      this.noteId = id;
      this.getDetail();
      this.formDialogTitle = "修改机构短信";
      this.$refs.formDialog.open();
    },
    getDetail() {
      const params = {
        id: this.noteId,
        userId: this.userId,
      };

      this.doLoad(
        OrganNoteService.detail,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogModel = result;
            this.getTatSimpleId = this.dialogModel.tatSimpleId;
            this.dialogModel.feeAmt = (this.dialogModel.feeAmt * 100) / 10000;
            this.dialogModel.feeType = this.dialogModel.feeType.toString();
            this.dialogModel.status = this.dialogModel.status.toString();
          });
        },
        "信息获取失败"
      );
    },
    getList() {
      this.doLoad(
        OrganNoteService.list,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            // const result = res.contents;
            // this.tableData = result.rows;
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    doDisabled(id) {
      const disabledParams = {
        id: id,
        userId: this.userId,
        status: this.status,
      };
      this.doLoad(
        OrganNoteService.dpstatus,
        disabledParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.showSuccess(result.optMsg);
            this.getList();
          });
        },
        "操作失败"
      );
    },
    Disabled(id, type) {
      if (type == 0) {
        this.status = 1;
        this.showMsg = "确定启用此机构短信？";
      } else if (type == 1) {
        this.status = 0;
        this.showMsg = "确定禁用此机构短信？";
      }
      this.showConfirm(this.showMsg)
        .then(() => {
          this.doDisabled(id);
        })
        .catch(() => {});
    },
    dialogSuccess(res) {
      this.doCheck(res, (res) => {
        this.showSuccess(res.respMsg);
        this.$refs.formDialog.closeDialog();
        this.getList();
      });
    },
    dialogClose() {
      this.dialogModel = {
        tatSimpleId: "",
        chnId: "",
        feeType: "",
        feeAmt: "0",
        status: "",
        desc: "",
      };
    },
    dialogOpen() {
      this.getchnNameList();
      // if (this.noteId) {
      //     this.getDetail();
      // }
    },
    checkOnly(val, onSuccess) {
      const params = {
        tatSimpleId: val,
      };
      this.doLoad(
        OrganNoteService.isExist,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            onSuccess && onSuccess(res);
          });
        },
        "信息获取失败"
      );
    },
    doDeleteInfo(id) {
      const disabledParams = {
        id: id,
      };
      this.doLoad(
        OrganNoteService.delInfo,
        disabledParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.showSuccess(result.optMsg);
            this.getList();
          });
        },
        "操作失败"
      );
    },
    DeleteInfo(id) {
      this.showMsg = "确定删除此机构短信？";
      this.showConfirm(this.showMsg)
        .then(() => {
          this.doDeleteInfo(id);
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/OrganNote.vue